import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'maskEmail',
  standalone: true,
})
export class MaskEmailPipe implements PipeTransform {
  transform(value: unknown): string {
    if (typeof value !== 'string' || !value.includes('@')) {
      return '';
    }

    const [localPart, domain] = value.split('@');

    if (localPart.length <= 1) {
      return value; // Not enough characters to mask
    }

    const maskedPart = '*'.repeat(localPart.length - 1);
    return `${localPart.charAt(0)}${maskedPart}@${domain}`;
  }
}
